/**
 * Slider para tarjetas de experiencia (responsivo 4→3→móvil scroll)
 */

if (document.getElementById("experiences-home")) {
  document.addEventListener("DOMContentLoaded", function () {
    const slideContainer = document.querySelector(".card-list");
    const prevSlideBtn = document.getElementById("prev-slide-experiences");
    const nextSlideBtn = document.getElementById("next-slide-experiences");
    const indicatorsContainer = document.getElementById("indicators");

    const cards = Array.from(document.querySelectorAll(".card-item"));

    let currentSlide = 0;
    let cardsPerSlide = getCardsPerSlide();
    let totalSlides = Math.ceil(cards.length / cardsPerSlide);

    function isMobile() {
      return window.innerWidth <= 620;
    }

    function getCardsPerSlide() {
      if (window.innerWidth <= 620) return 1;
      if (window.innerWidth <= 1023) return 2;
      if (window.innerWidth <= 1400) return 3;
      return 4;
    }

    function getSlideWidth() {
      const viewport = slideContainer.parentElement;
      return viewport.getBoundingClientRect().width;
    }

    function updateNavigation() {
      const mobile = isMobile();

      prevSlideBtn.classList.toggle("!p-hidden", mobile || currentSlide === 0);
      nextSlideBtn.classList.toggle("!p-hidden", mobile || currentSlide >= totalSlides - 1);

      indicatorsContainer.innerHTML = "";
      if (!mobile) {
        for (let i = 0; i < totalSlides; i++) {
          const indicator = document.createElement("span");
          indicator.className = "indicator p-w-2 p-h-2 p-bg-gray-border p-rounded-full p-cursor-pointer";
          if (i === currentSlide) indicator.classList.add("active", "p-bg-primary");
          indicator.addEventListener("click", () => {
            currentSlide = i;
            updateSlidePosition();
            updateNavigation();
          });
          indicatorsContainer.appendChild(indicator);
        }
      }
    }

    function updateSlidePosition() {
      if (isMobile()) {
        slideContainer.style.transform = "";
        return;
      }
      const slideWidth = getSlideWidth();
      slideContainer.style.transform = `translateX(-${currentSlide * slideWidth}px)`;
    }

    prevSlideBtn.addEventListener("click", function () {
      if (currentSlide > 0) {
        currentSlide--;
        updateSlidePosition();
        updateNavigation();
      }
    });

    nextSlideBtn.addEventListener("click", function () {
      if (currentSlide < totalSlides - 1) {
        currentSlide++;
        updateSlidePosition();
        updateNavigation();
      }
    });

    function onResize() {
      const newCPS = getCardsPerSlide();
      if (newCPS !== cardsPerSlide) {
        cardsPerSlide = newCPS;
        totalSlides = Math.ceil(cards.length / cardsPerSlide);
        currentSlide = Math.min(currentSlide, totalSlides - 1);
      }
      updateSlidePosition();
      updateNavigation();
    }

    function initializeSlider() {
      cardsPerSlide = getCardsPerSlide();
      totalSlides = Math.ceil(cards.length / cardsPerSlide);
      currentSlide = 0;
      updateNavigation();
      updateSlidePosition();
    }

    initializeSlider();
    window.addEventListener("resize", onResize);
  });
}
